import Component from '../core/Component'
import Scroll from '../services/Scroll'
import withMedia from '../core/withMedia'

class StickyCareerDetail extends Component {
    constructor(element) {
        super(element, {
            media: 'mediumUp',
        })

        this.ref = {
            stickyItem: null,
        }

        this.state = {
            layoutHeight: 0,
            itemHeight: 0,
            top: 0,
        }
    }

    prepare() {
        Scroll.on('scroll', this.handleScroll)
        Scroll.on('resize', this.handleResize)
        this.resize()
    }

    destroy() {
        Scroll.off('scroll', this.handleScroll)
        Scroll.off('resize', this.handleResize)
    }

    handleResize = () => {
        this.resize()
    }

    handleScroll = ({ offset: { y } }) => {
        this.render(y)
    }

    resize() {
        this.state.layoutHeight = this.element.getBoundingClientRect().height
        this.state.itemHeight = this.ref.stickyItem.getBoundingClientRect().height
        this.state.top = this.element.getBoundingClientRect().top
        this.render()
    }

    render(scrollTop) {
        const topViewport = this.state.top - scrollTop
        const endOfTransform = this.state.layoutHeight - this.state.itemHeight

        if (topViewport - 72 < 0 && -topViewport + 72 < endOfTransform) {
            this.ref.stickyItem.style.transform = `translateY(${-topViewport + 72}px)`
        }
    }
}

export default withMedia(StickyCareerDetail)
